<template>

    <div class="ccpay-my"    >
         <div class="ccpay-Receipt-header">
            <span>我的</span>
        </div>
        <div class="ccpay-my-header" >
            <div>
                
                <span class="ccpay-my-header-img" >
                
                 <!-- <img src="../../../static/img/222.jpg"/>  <img :src="headerimg" v-show="imgflag"/>
                   <input  type="file" class="fileHomeWorkBtn" @change='updateImg' ref='ipt'>
                    <a v-show="!imgflag"> 
                    设置头像</a> -->
                </span>
            
            </div> 
            <div>
                <p class="ccpay-my-header-name"><b>{{userinfo.name}}</b> <span>Lv.3</span></p>
                <p  class="fz14 c3" v-show="userinfo.invite_code">邀请码 : {{userinfo.invite_code}} 
                <span class="fl-r tag-read" :data-clipboard-text="userinfo.invite_code" @click="copy">复制</span></p>
            </div>
            <!-- <span class="ccpay-my-header-push ">></span> -->
        </div>
        <div class="ccpay-my-content" style="padding-left: 1rem;">
            <div class="ccpay-my-card">
                <ul>
                    <li class="fn">总余额<span class="fr-u">(USDT)</span>
                        <!-- <span>查看</span> -->
                     </li>
                    <li class="ccpay-my-card-price">{{Formatnumbers(number.Totalbalance,4,'.',',')}}</li>
                    <li class="fn">
                         <span>可用余额</span><span class="fr-u">(USDT)</span>
                        </li>
                    <li class="ccpay-my-card-price">
                        <span>{{Formatnumbers(number.available,4,'.',',')}}</span>
                    
                     </li>
                    <li class="fn">
                         <span>冻结余额</span><span class="fr-u">(USDT)</span>
                    </li>
                   <li class="ccpay-my-card-price">
                        <span>{{Formatnumbers(number.freeze_order_value,4,'.',',')}}</span>
                     </li>
                    <li class="ccpay-my-card-button"><button
                    @click="Recharge('add')">充值</button><button @click="Recharge('rem')">提现</button></li>
                </ul>
            </div>
            <div class="ccpay-my-liststyem">
              <ul>
                    <li >
                        <router-link to>身份认证</router-link>
                        <img class="app-cell-allow-right" src="../../../static/icon/you.png">
                    </li>
                    <li @click="pushdetail('/security')">
                        <router-link to>账户安全</router-link>
                        <img class="app-cell-allow-right" src="../../../static/icon/you.png">
                    </li>
                     <li @click="pushdetail('/Capital')">
                        <router-link to>资金流水</router-link>
                        <img class="app-cell-allow-right" src="../../../static/icon/you.png">
                    </li>
                    <li @click="pushdetail('/supplement')">
                        <router-link to>流水明细补充</router-link>
                        <img class="app-cell-allow-right" src="../../../static/icon/you.png">
                    </li>
                    <li @click="pushdetail('/Frenchhistory')">
                        <router-link to>法币补充历史</router-link>
                        <img class="app-cell-allow-right" src="../../../static/icon/you.png">
                    </li>
                    
                    <li >
                        <router-link to>保证金</router-link>
                        <span class="app-cell-ccpay-right">
                            <span v-show="number.freeze_margin_value<=0">未缴纳</span>
                            <span v-else>已缴纳 {{ Formatnumbers(number.freeze_margin_value,2,'.',',')  }}  USDT </span>
                        <img  src="../../../static/icon/you.png">
                        </span>

                    </li>
                    <!-- <li >
                        <router-link to>退出登录</router-link>
                    </li> -->

                </ul>
            </div>
            <p style="clear:both"  @click="back" class="ccpay-user-back">
                退出登录</p>
        </div>
    </div>

</template>

<script>
import { Indicator } from 'mint-ui';
import Clipboard from 'clipboard';
import {setCookie,setElpCookie,ccpayUser,getCookie,Formatnumbers} from '../../public/index.js'
export default {
    data(){
        return{
            userinfo:{},
            number:{
                 Totalbalance:'',//总余额
                 available:'',//可用余额
                 freeze_order_value:'',//冻结余额
                 freeze_margin_value:''//保证金冻结余额.
            },
            height:'',
            headerimg:'',
            imgflag:false
        }
    },
    mounted(){

        // console.log(this.userinfo,'userinfo')
        Indicator.open();
        this.$axios.get('/v1/account/info').then(res=>{
            if(res.code==0){
                ccpayUser(JSON.stringify(res.data),30)
                this.userinfo =   res.data
                 this.Quota()
            }
        })
    },
    methods:{
        Formatnumbers,
        setElpCookie,
        setCookie,
        getCookie,
        ccpayUser,
        pushdetail(type){
            this.$router.push({
                path:type
            })
        },
        //金额
        Quota(){
            this.$axios.get('/v1/account/amount?symbol=USDT').then(res=>{
                 Indicator.close();
             if(res.code==0){
                this.number.Totalbalance =   res.data.sum_amount
                this.number.available = res.data.available
                this.number.freeze_order_value = res.data.freeze_order_value
                this.number.freeze_margin_value = res.data.freeze_margin_value
                // console.log(res,'??????')
                 }
            })
        },
        goState(state,type){
            if(state){
                if(type=='add'){
                      this.$router.push({
                        path:'/Recharge'
                    })
                 }else{
                     this.$router.push({
                        path:'/CashWithdrawal'
                    })
                 }
            }else{
                this.$MessageBox.confirm('',{
                    title:'提示',
                    message:'没有绑定Google验证码，请先完成Google验证码绑定',
                    confirmButtonText:'去绑定',
                    cancelButtonText:'取消'
                }).then(action => {
                    this.$router.push({
                        path:'/Googlecode'
                    })

                }).catch(error =>{

                })
            }
        },
        //判断绑定谷歌验证码状态
        Recharge(type){
            Indicator.open();
            this.$axios.get('/v1/security/google/status').then(res=>{
                 Indicator.close();
                if(res.code==0){
                    if(res.data==1){
                        this.goState(true,type)
                    }else{
                         this.goState(false,type)
                    }
                }
            })

        },
        async updateImg(e) {
                let reader = new FileReader();
                let config = {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                };
                reader.readAsDataURL(e.target.files[0]);
                //console.log(reader)
                reader.onload = async() => {
                    // const datas = sumitImageFile(reader.result);
                    this.headerimg = reader.result
                    this.imgflag = true
                    //console.log(datas,"datas")
                    // this.$router.push({
                    //     name:'cropImage', 
                    //     query:{url:reader.result}
                    // })
                };
         },
        //退出登录
        back(){
             Indicator.open();
            this.$axios.get('/v1/login/exit').then(res=>{
                 Indicator.close();
                setElpCookie('elptoken','',-1,'')
                setCookie('ccpay-token','',-1)
                ccpayUser('',-1)
                this.$router.push({
                    path:'/phoneLogin'
                })
                 this.$Toast('请您重新登录')
            })
        },
        copy(){
            var clipboard = new Clipboard('.tag-read')
                clipboard.on('success', e => {
        //           console.log('复制成功')
                    this.$Toast('复制成功')
                  // 释放内存
                  clipboard.destroy()
                })
                clipboard.on('error', e => {
                  // 不支持复制
               this.$Toast('该浏览器不支持自动复制')
        //           console.log('该浏览器不支持自动复制')
                  // 释放内存
                  clipboard.destroy()
                })
        },
    }
}
</script>


<style lang="scss" scoped>
.ccpay-Receipt-header{
    font-weight: 500;
            border-bottom: 1px solid #ccc;
            padding-bottom: 0.2rem;
            position: fixed;
            top: 0;
            z-index: 999;
            height: 3rem;
            line-height: 3rem;
            width: 100%;
            background: white;
            display: flex;
            justify-content: space-around;
        }
.mint-msgbox .mint-msgbox-btns .mint-msgbox-btn{
    color:red ;
}
    .ccpay-my{
        background: white;
        // height: 100%;
        padding-right: 1rem;
        // padding-left: 1rem;
        padding-bottom: 4rem;
        .ccpay-my-header{
            padding-left: 1rem;
            position: relative;
         
            height: 4rem;
            padding: 1rem;
            padding-top: 4.5rem;
            // padding-left: 0;
            .ccpay-my-header-img{
                    width: 70px;
                    height: 70px;
                    display: inline-block;
                    background: #eee;
                    border-radius: 50%;
                    position: relative;
                    input{
                            position: absolute;
                            width: 70px;
                            height: 80px;
                            outline: none;
                            opacity: 0;
                            left: 0;
                                z-index: 9;
                    }
                    a{
                        position: absolute;
                        top: 40%;
                        font-size: 12px;
                        left: 12%;
                        color: #999;
                    }
            }
            div:nth-of-type(1){
                img{
                     width: 70px;
                     height: 70px;
                    object-fit: cover;
                    border-radius: 50%;
                }
                float: left;
                margin-right: 1rem;
            }
            div:nth-of-type(2){
                .ccpay-my-header-name{
                   
                    font-size: 18px;
                    b{
                         font-weight: 400;
                    }
                    span{
                            margin-left:0.5rem;
                            display: inline-block;
                           background: linear-gradient(45deg, black, transparent);
                           
                            // padding-left: 0.5rem;
                            // padding-right: 0.5rem;
                            // line-height: 1.5rem;
                            line-height: 0.1rem;
                            color: white;
                            padding: 0.7rem;
                            border-radius: 2px;
                             font-size: 12px;
                            // padding-left: 0.8rem;
                            // padding-right: 0.8rem;
                      }
                }
                p{
                    line-height: 2rem;
                }
            }
            .ccpay-my-header-push{
                position: absolute;
                right: 0rem;
                top: 35%;
                color: #ccc;
            }
        }
        .ccpay-my-card{
                box-sizing: border-box;
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
            -webkit-tap-highlight-color: transparent;
            background: white;
            --background: var(--ion-item-background, var(--ion-background-color, #fff));
            color: #666666;
            /* margin-left: 16px; */
            /* margin-right: 16px; */
            margin-top: 24px;
            margin-bottom: 24px;
            transform: translateZ(0px);
            font-size: 14px;
            box-shadow: rgba(0, 0, 0, 0.12) 0px 4px 16px;
            border-radius: 8px;
            transition: transform 500ms cubic-bezier(0.12, 0.72, 0.29, 1) 0s, -webkit-transform 500ms cubic-bezier(0.12, 0.72, 0.29, 1) 0s;
            // height: 200px;
            // background: #056e72;
            border-radius: 0.93rem;
            padding: 0.6rem ;
            margin-bottom: 1.5rem;
            li{
                position: relative;
                padding: 0.7rem ;
                // color: #ccc;
                font-size: 0.93rem;
                // border-bottom: 1px solid;
                // border-color: #eee;

            }
            .ccpay-my-card-button{
                button{
                    // color: white;
                    background: #eee;
                    /* opacity: 0.2; */
                    border: navajowhite;
                    padding: 0.8rem;
                    padding-left: 1.6rem;
                    padding-right: 1.6rem;
                    border-radius: 5px;
                    margin-right: 1rem;
                    outline: none;
                }
            }
        }


        .ccpay-my-liststyem{
            li{
                position: relative;
                padding: 1.125rem 0rem;
                color: #666;
                font-size: 0.93rem;
                border-bottom: 1px solid;
                border-color: #ccc;
                a{
                    color: #666;
                }
            }
            .app-cell-ccpay-right{
                float: right;
                padding: 0 0.5rem;
                span{
                    
                    color:#20ABFE;
                }
                img{
                    width: 0.625rem;
                    height: 0.625rem;
                }
            }
        }
        .ccpay-user-back{
            // position: relative;
             padding: 1rem 0rem;
            font-size: 0.93rem;
            // border: none;
            text-align: center;
            // background: #056e72;
            // color: white;
            margin-top: 2rem;
            margin-bottom: 1rem;
            // border: 1px solid #999;
            //  color: #999;
            //  background: #3880ff;
            background:#20ABFE;
            /* border: 1px solid #999; */
            color: white;
            border-radius: 10px;
        }
        .ccpay-my-card-price{
            span:nth-of-type(1){
                display: inline-block;
                width: 60%;
            }
        }
        .fn{
            // font-weight: 500;
              color: black;
        }
        .fr-u{
                float: right;
                font-size: 14px;
                color: #999;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/index/MyUser.vue